import Image from 'next/image';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Heat } from '../../../core/estimator/estimator.models';
import { InputField } from '../../atoms/input-field/InputField';

export const ValCharacteristics: React.FC<{
  onForward: (data: {
    heat: Heat;
    garden: string;
    balconySurface: string;
    garageSurface: string;
    lift: boolean;
  }) => void;
}> = ({ onForward }) => {
  const { t } = useTranslation(['valutatore']);
  const { t: tc } = useTranslation();
  const [heat, setHeat] = useState<Heat>('');
  const [garden, setGarden] = useState<string>('');
  const [existBalcony, setExistBalcony] = useState<boolean>(false);
  const [existGarage, setExistGarage] = useState<boolean>(false);
  const [balconySurface, setBalconySurface] = useState<string>('');
  const [garageSurface, setGarageSurface] = useState<string>('');
  const [lift, setLift] = useState<boolean>(false);

  return (
    <>
      <div className="valutatore__container__title">
        <Image
          src="/assets/img/valutatore/caratteristiche.jpg"
          alt="caratteristiche"
          width={32}
          height={32}
        />
        {t('step_four.title')}
      </div>
      <div className="login__form__field__row__label">
        {t('step_four.heat')}
      </div>
      <div className="valutatore__container--three_btns">
        {Object.entries(t('step_four.heatingValues')).map(
          ([key, value], index) => (
            <div
              key={index}
              className={
                'valutatore__container__choiche' +
                (heat === (key as Heat)
                  ? ' valutatore__container__choiche--selected'
                  : '')
              }
              onClick={() => {
                setHeat(key as Heat);
              }}
            >
              {value as string}
            </div>
          )
        )}
      </div>
      <div className="login__form__field__row__label">
        {t('step_four.garden')}
      </div>
      <div className="valutatore__container--three_btns">
        {(t('step_four.gardenType') as string[]).map(
          (val: string, index: number) => (
            <div
              key={index}
              className={
                'valutatore__container__choiche' +
                (garden === val
                  ? ' valutatore__container__choiche--selected'
                  : '')
              }
              onClick={() => setGarden(val)}
            >
              {val}
            </div>
          )
        )}
      </div>
      <div className="login__form__field__row__label">
        {t('step_four.other')}
      </div>
      <div className="valutatore__container--other">
        <div
          className={
            'valutatore__container__choiche' +
            (existBalcony ? ' valutatore__container__choiche--selected' : '')
          }
          onClick={() => {
            setExistBalcony((prevExistBalcony) => !prevExistBalcony);
          }}
        >
          {t('step_four.terrace')}
        </div>
        <div>
          {existBalcony && (
            <div className="valutatore__container--other__inputs">
              <InputField
                type="number"
                inputMode="numeric"
                name="balconySurface"
                placeholder={''}
                value={balconySurface}
                onChange={(value) => setBalconySurface(value)}
              />
              <span> {t('sqm')}</span>
            </div>
          )}
        </div>
        <div
          className={
            'valutatore__container__choiche' +
            (existGarage ? ' valutatore__container__choiche--selected' : '')
          }
          onClick={() => setExistGarage((prevExistGarage) => !prevExistGarage)}
        >
          {t('step_four.garage')}
        </div>
        <div>
          {existGarage && (
            <div className="valutatore__container--other__inputs">
              <InputField
                type="number"
                inputMode="numeric"
                name="garageSurface"
                placeholder={''}
                value={garageSurface}
                onChange={(value) => setGarageSurface(value)}
              />
              <span>{t('sqm')}</span>
            </div>
          )}
        </div>
      </div>
      <div className="login__form__field__row__label">
        {t('step_four.lift')}
      </div>
      <div className="valutatore__container--two_columns">
        <div
          className={
            'valutatore__container__choiche' +
            (lift ? ' valutatore__container__choiche--selected' : '')
          }
          onClick={() => setLift(true)}
        >
          {tc('yes')}
        </div>
        <div
          className={
            'valutatore__container__choiche' +
            (!lift ? ' valutatore__container__choiche--selected' : '')
          }
          onClick={() => setLift(false)}
        >
          {tc('no')}
        </div>
      </div>

      {!!garden && !!heat && (
        <div
          className="valutatore__container__button_forward"
          onClick={() =>
            onForward({
              heat,
              garden,
              balconySurface,
              garageSurface,
              lift,
            })
          }
        >
          {tc('next')}
        </div>
      )}
    </>
  );
};
